"use client";

import { BoxAlignProps } from "@/types";
//Styles
import * as S from "./styles";

const BoxAlign: React.FC<BoxAlignProps> = ({
  className,
  children,
  align,
  justify,
  gap,
  column = false,
  fullWidth = true,
  mb,
  fullHeight = false,
}) => {
  return (
    <S.Box
      className={className}
      $mb={mb}
      $align={align}
      $justify={justify}
      $gap={gap}
      $column={column}
      $fullWidth={fullWidth}
      $fullHeight={fullHeight}
    >
      {children}
    </S.Box>
  );
};

export default BoxAlign;
